import styled from '@emotion/styled';
import { Box } from '@mui/material';

export const CheckboxWrapper = styled(Box)`
  display: flex;
  padding: 0;
  flex-grow: 1;
  justify-content: end;
`;
